import type { WaterSavedPeriodType } from '../types/water-saved.ts';

/**
 * The calendar window of the quarter or year containing a month.
 * All dates are YYYY-MM-DD strings; the end is exclusive.
 *
 * Single source of truth for period boundary arithmetic — used by the
 * metrics-core executor (rollup upserts) and the frontend (drill-down range).
 */
export function waterSavedPeriodWindow(
  periodType: WaterSavedPeriodType,
  monthStart: string,
): { periodStart: string; periodEndExclusive: string; expectedMonthCount: number } {
  const year = parseInt(monthStart.slice(0, 4), 10);
  const month = parseInt(monthStart.slice(5, 7), 10);

  if (periodType === 'year') {
    return {
      periodStart: `${year}-01-01`,
      periodEndExclusive: `${year + 1}-01-01`,
      expectedMonthCount: 12,
    };
  }

  const quarterStartMonth = Math.floor((month - 1) / 3) * 3 + 1;
  const endMonth = quarterStartMonth + 3;
  const pad = (m: number) => String(m).padStart(2, '0');
  return {
    periodStart: `${year}-${pad(quarterStartMonth)}-01`,
    periodEndExclusive: endMonth > 12 ? `${year + 1}-01-01` : `${year}-${pad(endMonth)}-01`,
    expectedMonthCount: 3,
  };
}
